import {Component} from '@angular/core';

@Component({
    selector: 'app-finance-report',
    templateUrl: './finance-report.component.html',
    standalone: false
})
export class FinanceReportComponent {

}
